<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="EP">The biggest threat to world peace? Young men between the ages of eighteen and twenty-five, especially if they are unemployed, unmarried and don’t own property.</p>
<p class="EPC1"><span class="ePub-SC">DR CLAYBORNE CARSON</span></p>
<p class="EP">He may be a son-of-a-bitch but he’s our son-of-a-bitch.</p>
<p class="EPC"><span class="ePub-SC">FRANKLIN D. ROOSEVELT</span></p>
<p class="EPC">on President Somoza of Nicaragua</p>
<p class="EPC1">(attribution disputed)</p>
<p class="EP">Working in the fields, we wore out our hats quickly.</p>
<p class="EPC"><span class="ePub-SC">PRAMOEDYA ANANTA TOER</span>,</p>
<p class="EPC"><span class="ePub-I">The Mute’s Soliloquy</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraphs.vue?a522e494